import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const bageDirectory = 'additional/badges';
const imgDirectory = 'additional/backgrounds';
const skillBoxParent = {
    name: 'skillBox',
    serviceName: 'serviceSkillBox',
    serviceTitle: _jsx(_Fragment, { children: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0438\u00A0\u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u0434\u0435\u0442\u0435\u0439 \u0432\u00A0\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0435" }),
    title: _jsx(_Fragment, { children: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u0438\u00A0\u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u0434\u0435\u0442\u0435\u0439 \u0432\u00A0\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0435" }),
    text: _jsx(_Fragment, { children: "\u043E\u0442 Skillbox x \u041C\u0422\u0421 Junior" }),
    img: { alt: 'Skillbox', src: { fileName: 'additional-skillbox.png', directory: imgDirectory } },
    bage: {
        alt: 'Skillbox',
        src: { fileName: 'skillbox-badge.svg', directory: bageDirectory },
    },
    purpose: null,
    getPurchaseMethod: () => 'Бесплатный курс родителям',
    getButtonText: () => 'Узнать больше',
    externalLink: 'https://l.mts.ru/1/PtqCBL',
};
const robloxChild = {
    name: 'roblox',
    serviceName: 'serviceRoblox',
    serviceTitle: _jsx(_Fragment, { children: "\u0410\u0442\u0442\u0440\u0430\u043A\u0446\u0438\u043E\u043D\u044B \u0431\u0443\u0434\u0443\u0449\u0435\u0433\u043E" }),
    title: (_jsxs(_Fragment, { children: ["\u0410\u0442\u0442\u0440\u0430\u043A\u0446\u0438\u043E\u043D\u044B ", _jsx("br", {}), " \u0431\u0443\u0434\u0443\u0449\u0435\u0433\u043E"] })),
    text: (_jsxs(_Fragment, { children: ["\u0418\u0441\u0441\u043B\u0435\u0434\u0443\u0439 JUN-\u041F\u0410\u0420\u041A ", _jsx("br", {}), " \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0439 \u043F\u0440\u0438\u0437\u044B"] })),
    img: { alt: 'JUN-ПАРК', src: { fileName: 'additional-roblox.png', directory: imgDirectory } },
    bage: {
        alt: 'JUN-ПАРК',
        src: { fileName: 'roblox-badge.svg', directory: bageDirectory },
    },
    purpose: null,
    getPurchaseMethod: () => 'Входит в МТС Junior',
    getButtonText: () => 'Узнать больше',
    externalLink: 'https://l.mts.ru/1/TIYpLe',
};
const likeeChild = {
    name: 'likee',
    serviceName: 'serviceLikee',
    serviceTitle: _jsx(_Fragment, { children: "\u0423\u0447\u0430\u0441\u0442\u0432\u0443\u0439 \u0432\u00A0\u0447\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0430\u0445\u00A0\u041C\u0422\u0421 Junior" }),
    title: _jsx(_Fragment, { children: "\u0423\u0447\u0430\u0441\u0442\u0432\u0443\u0439 \u0432\u00A0\u0447\u0435\u043B\u043B\u0435\u043D\u0434\u0436\u0430\u0445\u00A0\u041C\u0422\u0421 Junior" }),
    text: _jsx(_Fragment, { children: "\u0412 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0435\u0442\u0438 Likee" }),
    img: { alt: 'Likee', src: { fileName: 'additional-likee.png', directory: imgDirectory } },
    bage: {
        alt: 'Likee',
        src: { fileName: 'likee-badge.svg', directory: bageDirectory },
    },
    purpose: null,
    getPurchaseMethod: () => 'Входит в МТС Junior',
    getButtonText: () => 'Узнать больше',
    externalLink: 'https://l.mts.ru/1/PBggkR',
};
const soon = {
    name: 'soon',
    serviceName: 'serviceSoon',
    serviceTitle: _jsx(_Fragment, { children: "\u0421\u043A\u043E\u0440\u043E\u00A0\u0432\u00A0\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0435" }),
    title: _jsx(_Fragment, { children: "\u0421\u043A\u043E\u0440\u043E\u00A0\u0432\u00A0\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0435" }),
    text: (_jsxs(_Fragment, { children: ["\u0423\u0436\u0435 \u043E\u0442\u043A\u0440\u044B\u0432\u0430\u0435\u043C ", _jsx("br", {}), " \u043F\u043E\u0440\u0442\u0430\u043B \u043D\u043E\u0432\u0438\u043D\u043E\u043A"] })),
    hideTextArrow: true,
    img: { alt: 'Skillbox', src: { fileName: 'additional-soon.png', directory: imgDirectory } },
    bage: {
        alt: '',
        src: { fileName: 'soon-badge.svg', directory: bageDirectory },
    },
    purpose: null,
    getPurchaseMethod: () => 'Новинки',
    getButtonText: () => '',
    externalLink: '',
};
export const additionalList = {
    parent: [skillBoxParent],
    child: [robloxChild, likeeChild],
};
export const additionalTitle = {
    parent: _jsx(_Fragment, { children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u043C\u0435\u0441\u0442\u0435 \u0441\u00A0\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u043E\u0439 \u041C\u0422\u0421\u00A0Junior" }),
    child: _jsx(_Fragment, { children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439 \u0432\u043C\u0435\u0441\u0442\u0435 \u0441\u00A0\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u043E\u0439 \u041C\u0422\u0421\u00A0Junior" }),
};
